<template>
  <WdsSelect
    v-model="selectedStatuses"
    multi-select
    data-test="linked-agency-invite-status-filter"
    :label="meta.filter.quickFilter ? '' : $t('Status')"
    :list="statusOptions"
    :placeholder="$t('All statuses')"
    can-deselect
    labels-primary
  />
</template>

<script setup lang="ts">
import { computed, ModelRef } from 'vue'
import { WdsSelect } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { RecruiterStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedStatuses: ModelRef<string[]> = defineModel({
  default: () => [],
})

const statusOptions = computed(() => [
  { label: $t('Active'), value: RecruiterStatus.Active },
  { label: $t('Invited'), value: RecruiterStatus.Invited },
])
</script>
